namespace GeniuzPOS.LogManage {
    export interface LogRefundRow {
        Id?: number;
        ShopId?: string;
        PosId?: string;
        DocNo?: string;
        Cashier?: string;
        RefDocNo?: string;
        CheckDoc?: number;
        FlagReceipt?: number;
        ShiftId?: number;
        CreateDate?: string;
    }

    export namespace LogRefundRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'LogManage.LogRefund';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            PosId = "PosId",
            DocNo = "DocNo",
            Cashier = "Cashier",
            RefDocNo = "RefDocNo",
            CheckDoc = "CheckDoc",
            FlagReceipt = "FlagReceipt",
            ShiftId = "ShiftId",
            CreateDate = "CreateDate"
        }
    }
}
